import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/logo/LIA_logo.png";

export default function TopBar() {
  const [menuOpen, setMenuOpen] = useState(false);          // Drawer toggle
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  const [resultsOpen, setResultsOpen] = useState(false);    // Mobile: RESULTS submenu toggle
  const [aboutOpen, setAboutOpen] = useState(false);        // Mobile: ABOUT US submenu toggle
  const location = useLocation();

  /* Listen to page width changes, dynamically distinguish desktop/mobile */
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 992);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  /* Lock page scroll when drawer is expanded */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
  }, [menuOpen]);

  /* Check if current route is programs-related page */
  const isProgramsActive = location.pathname.startsWith('/programs');
  const isResultsActive = [
    '/result',
    '/results',
    '/college_Acceptance',
    '/placementTest',
    '/sat-psat-results',
  ].includes(location.pathname);
  const isAboutActive = [
    '/about',
    '/about-lia',
    '/meet-our-teachers',
  ].includes(location.pathname);

  /* When viewport changes or drawer closes, collapse RESULTS submenu (mobile) */
  useEffect(() => {
    if (!isMobile || !menuOpen) {
      setResultsOpen(false);
      setAboutOpen(false);
    }
  }, [isMobile, menuOpen]);

  return (
    <header
      className="main-header clearfix"
      role="header"
      style={{ backgroundColor: "rgb(0, 48, 113)" }}
    >
      <div className="container" style={{ maxWidth: "100%", paddingLeft: "40px" }}>
        {/* ===== Left LOGO ===== */}
        <div className="logo" style={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="LIA Logo" style={{ height: "65px", marginRight: 12 }} />
          <a href="/" style={{ color: "#fff" }}>
            <em style={{ color: "#f9a825", fontStyle: "normal" }}>LIA</em>
            <strong className="learning-word">LEARNING</strong>
          </a>
        </div>

        {/* ===== Hamburger Button (only shown on mobile when not expanded) ===== */}
        {isMobile && !menuOpen && (
          <a
            href="#menu"
            className="menu-link"
            onClick={(e) => {
              e.preventDefault();
              setMenuOpen(true);
            }}
            aria-label="Open menu"
            aria-expanded={menuOpen}
          >
            <i className="fa fa-bars" />
          </a>
        )}

        {/* Background overlay */}
        {menuOpen && <div className="backdrop" onClick={() => setMenuOpen(false)} />}

        {/* ===== Right Drawer / Top Main Navigation ===== */}
        <nav id="menu" className={`main-nav ${menuOpen ? "active" : ""}`} role="navigation">
          {/* Close button in drawer */}
          {isMobile && menuOpen && (
            <a href="#!" className="close-link" onClick={() => setMenuOpen(false)}>
              <i className="fa fa-times" />
            </a>
          )}

          <div
            className="nav-actions"
            style={isMobile ? { width: "100%" } : { float: "right", paddingRight: "40px" }}
          >
            <ul className="main-menu">
              <li className={location.pathname === "/" ? "active" : ""}>
                <Link to="/" onClick={() => setMenuOpen(false)}>
                  HOME
                </Link>
              </li>

              {/* ===== PROGRAMS（普通链接） ===== */}
              <li className={isProgramsActive ? "active" : ""}>
                <Link to="/programs" onClick={() => setMenuOpen(false)}>
                  PROGRAMS
                </Link>
              </li>

              {/* ===== SAT / PSAT ===== */}
              <li className={location.pathname.startsWith('/sat-psat') ? "active" : ""}>
                <Link to="/sat-psat" onClick={() => setMenuOpen(false)}>
                  SAT / PSAT
                </Link>
              </li>

              {/* ===== RESULTS（含下拉） ===== */}
              <li className={`has-submenu ${isResultsActive ? "active" : ""}`}>
                <div className="programs-header">
                  {isMobile ? (
                    <a
                      href="#!"
                      aria-expanded={resultsOpen}
                      aria-label="Toggle RESULTS submenu"
                      onClick={(e) => {
                        e.preventDefault();
                        setResultsOpen((v) => !v);
                      }}
                      style={{ color: '#fff' }}
                    >
                      RESULTS
                    </a>
                  ) : (
                    <Link
                      to="/college_Acceptance"
                      onClick={() => {
                        setMenuOpen(false);
                        setResultsOpen(false);
                      }}
                    >
                      RESULTS
                    </Link>
                  )}
                  {/* 移动端不再显示下箭头，仅保留 RESULTS 按键 */}
                </div>
                <ul className="sub-menu" style={isMobile ? { display: resultsOpen ? 'block' : 'none' } : undefined}>
                  <li>
                    <Link to="/college_Acceptance" onClick={() => setMenuOpen(false)}>
                      College Acceptance
                    </Link>
                  </li>
                  <li>
                    <Link to="/placementTest" onClick={() => setMenuOpen(false)}>
                      Placement Test
                    </Link>
                  </li>
                  <li>
                    <Link to="/sat-psat-results" onClick={() => setMenuOpen(false)}>
                      SAT / PSAT Results
                    </Link>
                  </li>
                </ul>
              </li>

              {/* ===== ABOUT US（含下拉） ===== */}
              <li className={`has-submenu ${isAboutActive ? "active" : ""}`}>
                <div className="programs-header">
                  {isMobile ? (
                    <a
                      href="#!"
                      aria-expanded={aboutOpen}
                      aria-label="Toggle ABOUT US submenu"
                      onClick={(e) => {
                        e.preventDefault();
                        setAboutOpen((v) => !v);
                      }}
                      style={{ color: '#fff' }}
                    >
                      ABOUT US
                    </a>
                  ) : (
                    <Link
                      to="/about-lia"
                      onClick={() => {
                        setMenuOpen(false);
                        setAboutOpen(false);
                      }}
                    >
                      ABOUT US
                    </Link>
                  )}
                </div>
                <ul className="sub-menu" style={isMobile ? { display: aboutOpen ? 'block' : 'none' } : undefined}>
                  <li>
                    <Link to="/about-lia" onClick={() => setMenuOpen(false)}>
                      About LIA
                    </Link>
                  </li>
                  <li>
                    <Link to="/meet-our-teachers" onClick={() => setMenuOpen(false)}>
                      Meet our teachers
                    </Link>
                  </li>
                </ul>
              </li>
              <li className={location.pathname === "/join" ? "active" : ""}>
                <Link to="/join" onClick={() => setMenuOpen(false)}>
                  JOIN US
                </Link>
              </li>
              
              <li className={location.pathname === "/login" ? "active" : ""}>
                <Link to="/login" onClick={() => setMenuOpen(false)}>
                  LOGIN
                </Link>
              </li>
              
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}
